export var NODE_FIRMWARE_LOCATION = '/mnt/nvram/node_firmware';
